<template>
  <div class="mt-3">
    <b-form>
      <b-row>
        <b-col xl="4" lg="4" sm="6">
          <p class="mt-3">
            <span class="h3">IMSI</span>
          </p>
        </b-col>
        <b-col xl="8" lg="8" sm="6">
          <b-form-group label-for="input-1">
            <b-form-input
              type="text"
              :state="!submitDisabled"
              v-model="cancelLocationForm.imsiInfo"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" lg="4" sm="6">
          <p class="mt-3">
            <span class="h3">Destination Address</span>
          </p>
        </b-col>
        <b-col xl="8" lg="8" sm="6">
          <b-form-group
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              :state="true"
              v-model="cancelLocationForm.addressInfo"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" lg="4" sm="6">
          <p class="mt-3">
            <span class="h3">Action</span>
          </p>
        </b-col>
        <b-col xl="8" lg="8" sm="6">
          <b-form-group label="" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="cancelLocationForm.actionInfo"
              :options="actionOptions"
              :state="true"
              value-field="key"
              text-field="text"
              plain
              stacked>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="danger" title="Close"  v-on:click="modalClose()">
            Close
        </base-button>
        <base-button type="primary" title="Search" :disabled="submitDisabled" v-on:click="cancelLocationSubmit" :loading="submitLoading">
            Submit
        </base-button>
      </div>
    </b-form>
  </div>
</template>

<script>
  import searchDetailService from "../../common/api-services/search-details-service";
  import handleResponse from "../../common/directive/handlResponse";

  export default {
    name: "Cancel-Location",
    data() {
      return {
        actionOptions: [
          {text: 'Cancel Voice', key: 'Voice'},
          {text: 'Cancel Data', key: 'Data'},
          {text: 'Cancel Voice and Data', key: 'All'}
        ],
        cancelLocationForm: {
          imsiInfo: '',
          addressInfo: '',
          actionInfo: ''
        },
        submitLoading: false
      }
    },
    computed: {
      submitDisabled() {
        return !this.cancelLocationForm.imsiInfo.length > 0;
      }
    },
    mounted() {
      this.$root.$on('cancelLocationData', (imsi) => {
        this.cancelLocationForm.imsiInfo = imsi;
      })
    },
    methods: {
      cancelLocationSubmit() {
        this.submitLoading = true;
        let {imsiInfo, addressInfo, actionInfo} = this.cancelLocationForm;
        searchDetailService.cancelLocation(imsiInfo, addressInfo, actionInfo).then(res => {
          this.submitLoading = false;
          let {type, msg} = handleResponse.apiResponse(res);
          this.modalClose();
          this.$toast(msg, {type: type})
        })
      },

      modalClose() {
        this.$bvModal.hide('cancel-location')
      },
    },

  }
</script>
